import createLucideIcon from '../createLucideIcon';

const Voicemail = createLucideIcon('VoicemailIcon', [
  ['circle', { cx: '6', cy: '12', r: '4', key: '1ehtga' }],
  ['circle', { cx: '18', cy: '12', r: '4', key: '4vafl8' }],
  ['line', { x1: '6', y1: '16', x2: '18', y2: '16', key: '1xgyj1' }],
]);

export default Voicemail;
